import React from 'react';
import {
  Button,
  Badge,
  Separator,
  DropdownMenuCheckboxItem,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@cargomatic/ui';
import { PlusCircle } from 'lucide-react';
import { cn } from 'utils/ui/classes';

export function DataTableFilter({ column, title, options, className }) {
  const selectedValues = new Set(column?.getFilterValue());

  function handleFilterChange(option) {
    return (checked) => {
      if (!checked) {
        selectedValues.delete(option.value);
      } else {
        selectedValues.add(option.value);
      }
      const filterValues = Array.from(selectedValues);
      column?.setFilterValue(filterValues.length ? filterValues : undefined);
    };
  }

  function handleReset() {
    column.setFilterValue(undefined);
  }

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="border-dashed flex items-center"
        >
          <PlusCircle className="mr-2 h-4 w-4" />
          {title}
          {selectedValues?.size > 0 && (
            <>
              <Separator orientation="vertical" className="mx-2 h-4" />
              <Badge className="rounded-sm px-1 font-normal lg:hidden">
                {selectedValues.size}
              </Badge>
              <div className="hidden space-x-1 lg:flex">
                {selectedValues.size > 2 ? (
                  <Badge className="rounded-sm px-1 font-normal">
                    {selectedValues.size} selected
                  </Badge>
                ) : (
                  (options || [])
                    .filter((option) => selectedValues.has(option.value))
                    .map((option) => (
                      <Badge
                        key={option.value}
                        className="rounded-sm px-1 font-normal"
                      >
                        {option.label}
                      </Badge>
                    ))
                )}
              </div>
            </>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={cn('w-[200px] p-0 overflow-y-auto', className)}
        align="start"
      >
        {options.map((option) => {
          const isSelected = selectedValues.has(option.value);

          return (
            <DropdownMenuCheckboxItem
              key={option.value}
              onCheckedChange={handleFilterChange(option)}
              checked={isSelected}
            >
              <span>{option.label}</span>
            </DropdownMenuCheckboxItem>
          );
        })}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleReset} className="pl-8">
          Clear
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
